import axiosInstance from '../axiosInterceptor/axiosInstance'

const getDownloadRecordingUrl = async (data) => {
  const { orgId, streamId } = data
  const url = `v1/orgs/${orgId}/streams/${streamId}/recording/download-link`
  const response = await axiosInstance.post(url)
  return response?.data
}

export default getDownloadRecordingUrl
